var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "border rounded p-1",
    class: {
      disabled: _vm.disabled
    }
  }, [_vm._l(_vm.tags, function (tag, index) {
    return _c('b-badge', {
      key: index,
      staticClass: "m-1",
      attrs: {
        "variant": "dark"
      }
    }, [_vm._v(" " + _vm._s(tag) + " "), _c('button', {
      staticClass: "btn btn-xs p-0",
      on: {
        "click": function click($event) {
          return _vm.handleClickRemoveTag(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove text-white"
    })])]);
  }), _c('b-input', {
    staticClass: "border-0",
    attrs: {
      "type": "text",
      "maxlength": _vm.tagMaxLength,
      "placeholder": "輸入標籤",
      "disabled": _vm.disabled
    },
    on: {
      "keyup": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleEnterInputTag.apply(null, arguments);
      }, _vm.handleKeyUpInputTag],
      "blur": _vm.handleEnterInputTag
    },
    model: {
      value: _vm.inputTag,
      callback: function callback($$v) {
        _vm.inputTag = $$v;
      },
      expression: "inputTag"
    }
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }